module.exports = __webpack_public_path__ + "static/media/mobile_specs@2x.d1c1bc3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/design-specifications/assets/mobile_specs@2x.png
// module id = 74
// module chunks = 0